import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34415632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "colleague" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "You will be working with", -1))
const _hoisted_4 = { class: "colleagues" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "positions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colleagues, (colleague) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "colleague-holder",
            key: colleague.name
          }, [
            (colleague.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require(`@/assets/img/people/${colleague.image}.png`),
                  alt: colleague.name
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", null, _toDisplayString(colleague.name), 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colleague.positions, (position) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "position",
                    key: position
                  }, _toDisplayString(position), 1))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}